import {Loading} from '@hm/fundamental'
import {buildFeatureUrl} from '@hproduce/suite-core'
import React from 'react'
import {Navigate} from 'react-router'

import {useHierarchyIdFromURL} from '../Components/Base/header/PlantSelectButton/useHierarchyIdFromUrl'

import {ROUTES} from './routing/routes'
import {useFeaturesMenu} from './welcomeFlow/useFeaturesMenu'

export const HomePageGuard: React.FC = () => {
  const {homeFeature, isLoading} = useFeaturesMenu()
  const [hierarchyId] = useHierarchyIdFromURL()

  if (isLoading) {
    return (
      <div className="h-screen flex items-center justify-center">
        <Loading size="large" data-cy="feature_menu_loader" />
      </div>
    )
  }

  if (!homeFeature) {
    return <Navigate to={ROUTES.NOT_FOUND.path} />
  }

  return <Navigate to={buildFeatureUrl(homeFeature.name, hierarchyId)} />
}
